<template>
  <v-container class="mb-5 pa-5 bg" v-editable="blok">
    <v-row>
      <v-container class="px-5">
        <v-row justify="center" v-if="story">
          <v-col cols="12">
            <div class="title mb-5">
              <h2>{{blok.title}}</h2>
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="4" class="d-flex" v-for="(item, index) in story" :key="index">
            <v-card class="text-left card pa-5" tile dark :to="`/${item.full_slug}`">
              <em>{{item.content.category}}</em>
              <h4>{{item.content.title}}</h4>
              <em>{{item.content.date}}</em>
              <p>{{item.content.shortDescription}}</p>
            </v-card>
          </v-col>
          <v-col cols="12">
            <div class="pagination mt-5 mb-5" v-if="Math.ceil(pagination.total/pagination.per_page)>1">
              <v-btn
                text
                v-for="(item, index) in Math.ceil(pagination.total/pagination.per_page)"
                :key="index"
                x-small
                :class="{ active: ((index+1) == pagination.page)  }"
                @click="setPage(index+1)"
              >{{index+1}}</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
  </v-container>
</template>


<style lang="scss" scoped>
@import "./BlogArticles.scss";
</style>

<script>
// 1. Require the Storyblok client
import StoryblokClient from "storyblok-js-client";

// 2. Set your token
const token = "vNbkVTgCgnArqEk6TG7LQwtt";

// 3. Initialize the client with the preview token so we can access our API easily
// from your space dashboard at https://app.storyblok.com
let storyapi = new StoryblokClient({
  accessToken: token
});
export default {
  data() {
    return {
      story: null,
      pagination: {
        page: 1,
        per_page: 12,
        total: 0
      }
    };
  },
  mounted() {
    // 4. Initialize the Storyblok Client Bridge to allow us to subscribe to events
    // from the editor itself.
    window.storyblok.init({
      accessToken: token
    });
    window.storyblok.on("change", () => {
      this.getBlogs(`${this.blok.lenguage}/blog-articles`, "draft");
    });
    window.storyblok.pingEditor(() => {
      if (window.storyblok.isInEditor()) {
        // draft will be loaded if embeded in app.storyblok.com
        this.getBlogs(`${this.blok.lenguage}/blog-articles`, "draft");
      } else {
        // published versions will be loaded outside of app.storyblok.com
        // so make sure to published your entries - otherwise this will be a 404
        this.getBlogs(`${this.blok.lenguage}/blog-articles`, "published");
      }
    });
  },
  methods: {
    setPage(page) {
      this.pagination.page = page;
      window.storyblok.pingEditor(() => {
        if (window.storyblok.isInEditor()) {
          // draft will be loaded if embeded in app.storyblok.com
          this.getBlogs(`${this.blok.lenguage}/blog-articles`, "draft");
        } else {
          // published versions will be loaded outside of app.storyblok.com
          // so make sure to published your entries - otherwise this will be a 404
          this.getBlogs(`${this.blok.lenguage}/blog-articles`, "published");
        }
      });
    },
    getBlogs(slug, version) {
      storyapi
        .get("cdn/stories/", {
          version: version,
          starts_with: slug,
            excluding_ids:'12902582,13001305',
          sort_by: "created_at:asc",
          page: this.pagination.page,
          per_page: this.pagination.per_page
        })
        .then(response => {
          this.story = response.data.stories;
          if (this.pagination.total === 0) {
            this.pagination.total = response.total;
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  props: ["blok"]
};
</script>
